import styles from "./ActorsCell.module.scss";
import { RequirementChip } from "@/components/Chips/RequirementChip";
import { getUnfulfilledRequirements } from "@medoma/models/activityRequirements";
import { AssignedShiftChip } from "@/components/Chips/AssignedShiftChip";
import {
  activityOccurrenceStatusSchema,
  type IActivityOccurrenceOrGroup,
  visitStatusSchema,
} from "@medoma/models/activities";
import { categorySchema, isGroup } from "@medoma/models/activities";

type IActorsCell = {
  activityOccurrenceOrGroup: IActivityOccurrenceOrGroup;
};

export const ActorsCell = ({ activityOccurrenceOrGroup }: IActorsCell) => {
  const assignees = isGroup(activityOccurrenceOrGroup)
    ? activityOccurrenceOrGroup.assignees
    : activityOccurrenceOrGroup.category === categorySchema.enum.PatientTask ||
        activityOccurrenceOrGroup.category ===
          categorySchema.enum.PatientMeasurementTask
      ? []
      : activityOccurrenceOrGroup.assignees;

  const requiredCompetences =
    activityOccurrenceOrGroup.category === categorySchema.enum.PatientTask ||
    activityOccurrenceOrGroup.category ===
      categorySchema.enum.PatientMeasurementTask
      ? []
      : activityOccurrenceOrGroup.requiredCompetences;

  const needsDoubleStaffing =
    activityOccurrenceOrGroup.category === categorySchema.enum.HomeVisit &&
    activityOccurrenceOrGroup.doubleStaffing;

  if (
    (!isGroup(activityOccurrenceOrGroup) &&
      activityOccurrenceOrGroup.status ===
        activityOccurrenceStatusSchema.enum.finished) ||
    (isGroup(activityOccurrenceOrGroup) &&
      activityOccurrenceOrGroup.visitStatus ===
        visitStatusSchema.enum.finished) ||
    activityOccurrenceOrGroup.category === categorySchema.enum.PatientTask ||
    activityOccurrenceOrGroup.category ===
      categorySchema.enum.PatientMeasurementTask
  ) {
    if (assignees.length === 0) {
      return null;
    }

    return (
      <ul className={styles.assignees}>
        {assignees.map((shift) => (
          <li key={shift.id}>
            <AssignedShiftChip
              medicalCompetence={shift.competence}
              shift={shift}
              size="small"
            />
          </li>
        ))}
      </ul>
    );
  }

  const unfulfilledRequirements = getUnfulfilledRequirements({
    assignees,
    requiredCompetences,
    doubleStaffing: needsDoubleStaffing,
  });

  return (
    <div className={styles.actorsCell}>
      {unfulfilledRequirements.length > 0 ? (
        <ul className={styles.competences}>
          {unfulfilledRequirements.map((unfulfilledRequirement) => (
            <li key={unfulfilledRequirement}>
              <RequirementChip
                requirement={unfulfilledRequirement}
                state="unfulfilled"
                size="small"
              />
            </li>
          ))}
        </ul>
      ) : null}
      {assignees.length > 0 ? (
        <ul className={styles.assignees}>
          {assignees.map((shift) => (
            <li key={shift.id}>
              <AssignedShiftChip
                medicalCompetence={shift.competence}
                shift={shift}
                size="small"
              />
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
